<mps-loader></mps-loader>
<div class="skiplinks">
  <nav role="navigation" [attr.aria-label]="'skiplinks.quick_access' | translate">
    <ul class="skiplinks__list">
      <li>
        <a id="skiplink__content" href="home#content" class="link">
          {{ 'skiplinks.content' | translate }}
        </a>
      </li>
      <li>
        <a id="skiplink__menu" href="home#main-nav" class="link">
          {{ 'skiplinks.menu' | translate }}
        </a>
      </li>
      <li>
        <a id="skiplink__pied-de-page" href="home#footer" class="link">
          {{ 'skiplinks.footer' | translate }}
        </a>
      </li>
    </ul>
  </nav>
</div>
<mat-sidenav-container class="h-100">
  <mat-sidenav id="main-nav" #snav position="end" mode="over" (openedChange)="onSidenavToggle($event)">
    <mps-app-navigation></mps-app-navigation>
  </mat-sidenav>
  <mat-sidenav-content class="app-sidenav-content">
    <mps-app-header [nav]="snav"></mps-app-header>
    <app-admin-view-as-banner></app-admin-view-as-banner>
    <main id="content">
      <router-outlet></router-outlet>
    </main>
    <mps-app-footer id="footer"></mps-app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
